import styled from "styled-components"

export const TabsWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 20px;
	button {
		border-radius: 4px;
		padding: 12px 24px;
		border: 1px solid #e5e3f8;
		background-color: #fff;
		color: #435363;
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 8px;
		cursor: pointer;
		&.active {
			color: #ffffff;
			background-color: #5b3fff;
			border: 1px solid #5b3fff;
		}
	}
`
